import { render, staticRenderFns } from "./ScoreEntry.vue?vue&type=template&id=3d83db32&scoped=true&"
import script from "./ScoreEntry.vue?vue&type=script&lang=js&"
export * from "./ScoreEntry.vue?vue&type=script&lang=js&"
import style0 from "./ScoreEntry.vue?vue&type=style&index=0&id=3d83db32&scoped=true&lang=css&"
import style1 from "./ScoreEntry.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d83db32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VCol,VForm,VRow,VSimpleTable})
